import { render, staticRenderFns } from "./ListaDeMaiorMenorUso.vue?vue&type=template&id=9b6000cc&scoped=true&"
import script from "./ListaDeMaiorMenorUso.vue?vue&type=script&lang=js&"
export * from "./ListaDeMaiorMenorUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6000cc",
  null
  
)

export default component.exports